import Overview from '@rebuild/materials/shared/report/Overview.vue';
import Full from '@rebuild/materials/shared/report/Full.vue';
import Detail from '@rebuild/materials/shared/report/Detail.vue';

export const componentMap = {
	overview: Overview,
	full: Full,
	detail: Detail
};
